import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_sermon_series = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/sermon/series`,
        method: 'GET',
        credentials: 'include'
    })
}

export const create_sermon_series = async (seriesData) => {
    if (!seriesData) return { error: 'No series data provided' }
    return await serverFetch({
        endpoint: `${config.endpoint}/sermon/series`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(seriesData),
        credentials: 'include'
    })
}
